export default __webpack_public_path__ + "static/media/a017-line4.f82447f7.svg";